import { useBooleanState } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';

import { FeedContainer } from './FeedContainer';
import { FullscreenViewContainer } from './FullscreenViewContainer';
import { trackEntryIntoView, trackOfferHistoryExist } from './analytics';
import { useActiveCategory } from './utils/useActiveCategory';
import { useHandleOfferRowClick } from './utils/useHandleOfferRowClick';
import { useTitle } from './utils/useTitle';
import { getOffersHistorySpoiler, setCategoriesFilter, setIsFiltersChanged } from '../../../actions/offersHistory';
import { selectOffersHistorySpoilerData } from '../../../selectors/offersHistory';
import { mapOfferCategoriesEnums } from '../../../store/offerHistory';
import { OpenFullscreenBtn } from '../components';
import { CategoryTabs } from '../components/CategoryTabs';
import { OfferHistoryNew } from '../components/OfferHistoryNew';

export const OfferHistoryContainer: React.FC = () => {
  const dispatch = useDispatch();
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const fullscreenOpenState = useBooleanState(false);
  const [, openFullscreenView] = fullscreenOpenState;
  const { data: offersHistorySpoilerData, isFetching } = useSelector(selectOffersHistorySpoilerData);

  const title = useTitle();
  const [activeCategory, handleActiveCategoryChange] = useActiveCategory();

  const handleOfferClick = useHandleOfferRowClick(openFullscreenView);

  const handleFullscreenClose = React.useCallback(() => {
    if (offersHistorySpoilerData?.filters?.activeCategory) {
      dispatch(setCategoriesFilter(mapOfferCategoriesEnums[offersHistorySpoilerData.filters.activeCategory]));
    }
  }, [dispatch, offersHistorySpoilerData]);

  React.useEffect(() => {
    if (!offersHistorySpoilerData) {
      dispatch(getOffersHistorySpoiler());
    }

    return () => {
      dispatch(setIsFiltersChanged(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  React.useEffect(() => {
    if (isFirstLoad && offersHistorySpoilerData?.offers.length) {
      trackOfferHistoryExist();
      setIsFirstLoad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offersHistorySpoilerData]);

  if (!offersHistorySpoilerData || !offersHistorySpoilerData.offers.length) {
    return null;
  }

  return (
    <CardSectionNew title={title}>
      <OfferHistoryNew
        tabs={
          offersHistorySpoilerData.filters ? (
            <CategoryTabs
              {...offersHistorySpoilerData.filters}
              activeCategory={activeCategory || offersHistorySpoilerData.filters.activeCategory}
              onTabClick={handleActiveCategoryChange}
            />
          ) : undefined
        }
        offersTableSmall={<FeedContainer onOfferClick={handleOfferClick} isSpoiler />}
        fullscreenViewBtn={
          offersHistorySpoilerData.totalCountText && !isFetching ? (
            <OpenFullscreenBtn
              onClick={handleOfferClick}
              text={offersHistorySpoilerData.totalCountText}
              onView={trackEntryIntoView}
            />
          ) : undefined
        }
        fullscreenView={
          <FullscreenViewContainer fullscreenOpenState={fullscreenOpenState} onClose={handleFullscreenClose} />
        }
      />
    </CardSectionNew>
  );
};
